import { clubApi, silentErrors } from "./axios";

// Salon subscription and in-app renewal (the landing only sells the first package).
export type SubscriptionStatus = "Active" | "Grace" | "Expired";
export type CurrentSubscription = {
  planCode: string; planName: string; startDate: string; endDate: string; daysLeft: number;
  status: SubscriptionStatus; graceEndDate?: string | null; requiresContractSignature?: boolean;
};
export type SubscriptionPlan = { code: string; name: string; months: number; price: number; listPrice?: number | null; badge?: string | null };
export type SubscriptionPayment = { id: number; planCode: string; amount: number; method: string; status: string; paidAt?: string | null; startDate?: string | null; endDate?: string | null };
export type PaymentOptions = { snappPay?: { eligible: boolean; title?: string | null; description?: string | null } | null; online?: { enabled: boolean } | null };
export type RenewalMethod = "SnappPay" | "Online";

const http = clubApi.instance;

export const subscriptionService = {
  // Silent: until the backend ships these endpoints the app simply shows nothing.
  current: async () => (await http.get<CurrentSubscription>("/api/Subscription/Current", silentErrors)).data,
  plans: async () => (await http.get<SubscriptionPlan[]>("/api/Subscription/Plans")).data,
  history: async () => (await http.get<SubscriptionPayment[]>("/api/Subscription/History")).data,
  paymentOptions: async (planCode: string) => (await http.get<PaymentOptions>("/api/Subscription/Renewals/PaymentOptions", { params: { planCode } })).data,
  renew: async (planCode: string, method: RenewalMethod) =>
    (await http.post<{ renewalId: number; paymentPageUrl: string }>("/api/Subscription/Renewals", { planCode, method })).data,
  inquiry: async (id: number) => (await http.post<{ status: string; endDate?: string | null }>(`/api/Subscription/Renewals/${id}/Inquiry`)).data,
};

export { SUBSCRIPTION_EXPIRED_EVENT } from "./subscriptionEvents";
